import React from 'react'
import { Bars } from 'react-loader-spinner';
import { styled } from '@mui/material/styles';

const Loader = () => {

    const LoaderOverlay = styled('div')(() => ({
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(52, 51, 51, 0.6)', // sky blue with transparency
        backdropFilter: 'blur(4px)', // stronger blur for smoother background
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        transition: 'all 0.3s ease-in-out',
    }));


    return (
        <div>
            <LoaderOverlay
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
            >
                <Bars
                    height="80"
                    width="80"
                    color="#0D6EFD"
                    ariaLabel="bars-loading"
                    visible={true}
                />
            </LoaderOverlay>
        </div>
    )
}

export default Loader
